import { useEffect, useState } from 'react'
import { API_URL, getClassNameForField, projectJourneyFields as fields } from '../../constants'
import { EditableFormPage } from '../components/EditableFormPage'
import { useParams } from 'react-router-dom'
import { Button } from '../../shared/components/Button'
import { FaTrash } from 'react-icons/fa'
import { useDeleteItem } from '../../util/deleteItem'
import ConfirmDeleteModal from '../components/DeleteModal'
import { useTranslationService } from '../../util/TranslationContext'
import { useTranslation } from 'react-i18next'
import { languageUtil } from '../../util/languageUtils'

const ProjectJourneySlug = () => {
    const [showConfirm, setShowConfirm] = useState(false)
    const [options, setOptions] = useState([])

    const { translateFields } = useTranslationService()
    const projectJourneyFields = translateFields(fields, 'project_journeys')
    const { t } = useTranslation()
    const { language } = languageUtil()
    const { id } = useParams()

    const deleteItem = useDeleteItem()

    useEffect(() => {
        const fetchOptions = async () => {
            try {
                const token = localStorage.getItem('token')
                const response = await fetch(`${API_URL}/admin/projects`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Accept-Language': language,
                    },
                })
                const result = await response.json()

                // Assuming response.data.data is the array of categories
                const mappedOptions = result.data.map(item => ({
                    label: item.title,
                    value: item.id,
                }))
                setOptions(mappedOptions)
            } catch (error) {
                console.error('Error fetching options:', error)
            }
        }

        fetchOptions()
    }, [language])

    const handleDelete = async () => {
        await deleteItem({
            url: `admin/project-journeys/${id}`,
            navigateSuccess: '/admin/auth/project-journeys',
            onError: msg => alert(msg),
        })
    }

    return (
        <>
            <div className='flex items-center justify-between'>
                <Button variant='danger' className='mb-4' onClick={() => setShowConfirm(true)}>
                    <FaTrash /> {t('status.delete')}
                </Button>

                <ConfirmDeleteModal
                    isOpen={showConfirm}
                    onClose={() => setShowConfirm(false)}
                    onConfirm={handleDelete}
                />
            </div>
            <EditableFormPage
                fetchUrl={`admin/project-journeys/${id}`}
                submitUrl={`admin/project-journeys/${id}?_method=PUT`}
                fields={projectJourneyFields}
                classNameForField={getClassNameForField}
                options={options}
            />
        </>
    )
}

export default ProjectJourneySlug
